import { coreStakeholdersIdMapSlice } from './_idMap/update';
import { CoreStakeholdersName } from './name';
import { createPatchAsyncSlice } from '@sonar-software/xuder';
import { patchStakeholder } from '@api';

export const coreStakeholdersPatchAsyncSlice = createPatchAsyncSlice({
	httpSagaOptions: {
		successCombinationActionCreators: [
			(request) => coreStakeholdersIdMapSlice.syncActionCreator([ { ...request } ])
		]
	},
	name: CoreStakeholdersName,
	receive: false,
	request: true,
	requestHandler: patchStakeholder
});
